import axios from 'axios';

const model = 'Pregunta'
const API_URL = process.env.VUE_APP_API_URL;

export default {
  get(page, size) {
    return axios.get(`${API_URL}/${model}/v1/list/${page}/${size}`);
  },

 saveQuestions(payload) {
    return axios.post(`${process.env.VUE_APP_API_URL_LOCAL}/v2/save/question`, payload)
      .then(response => {
        console.log('Pregunta guardada con éxito:', response.data);
        return response.data; // Devuelve los datos de la respuesta si es necesario
      })
      .catch(error => {
        console.error('Error al guardar la pregunta en el backend:', error);
        throw error; // Propaga el error para manejarlo en el componente
      });
  },

async uploadQuestionImage(formData) {
  try {
    const response = await axios.post(
      `${process.env.VUE_APP_API_URL_LOCAL}/v2/preguntas/upload-imagen`,
      formData,
      {
        headers: {
          // Authorization: `Bearer ${store.getters['auth/access-token']}`,
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response;
  } catch (error) {
    throw new Error(`Error uploading image: ${error.message}`);
  }
},

async getQuestionsByUnitAndChapter({ idEjeTematico, idCapitulo }) {
  try {
    const response = await axios.get(
      `${process.env.VUE_APP_API_URL_LOCAL}/v2/preguntas/por-unidad-y-capitulo`,
      {
        params: { idEjeTematico, idCapitulo },
      }
    );
    return response;
  } catch (error) {
    throw new Error(`Error fetching questions: ${error.message}`);
  }
},


 UpdatePortadaVideo(id_video) {
    return axios.get(`${process.env.VUE_APP_API_URL_LOCAL}/v2/video/update-portada/${id_video}`);
  },



  actualizar(id, usuario) {
    return axios.put(`${API_URL}/${model}/v1/${id}`, usuario);
  },

  eliminar(id) {
    return axios.delete(`${API_URL}/${model}/v1/${id}`);
  },

  buscarPorMail(email) {
    return axios.get(`${API_URL}/${model}/v1/buscar/${email}`)
  },


}